import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IUf } from '../types/IUf';

@Injectable({ 'providedIn': 'root' })
export class FilterableUfService {
  public host = environment.api.host;
  public methods = environment.api.endpoints.methods.corretor;

  constructor(
    private http: HttpClient,
  ) {}

  getUfs() {
    const url = this.host + this.methods.get.ufs;

    return this.http.get<IUf[]>(url);
  }
}